<div class="options-modal">
  <div>
    <page-alert *ngIf="submittedRequest && successSubmited" message="Salvo com sucesso!" alertClass="alert-success"></page-alert>
    <page-alert *ngIf="submittedRequest && !successSubmited" message="Falha ao processar solicitação!" alertClass="alert-danger"></page-alert>
  </div>
  <h2>Opções para o dia</h2>
  <p class="date">{{ data.param.date | date : 'fullDate' : '' : 'pt-BR' }}</p>

  <mat-radio-group [(ngModel)]="selectedOption" class="option-group">
    <mat-radio-button value="blockSchedule">Bloquear agendamento para esse dia</mat-radio-button>
    <mat-radio-button value="holiday">Declarar dia como feriado</mat-radio-button>
  </mat-radio-group>

  <div class="actions">
    <button mat-button (click)="close()">Fechar</button>
    <button mat-button color="primary" *ngIf="!data.param.existingModification" (click)="save()">Salvar</button>
    <button mat-button color="warn" *ngIf="data.param.existingModification" (click)="remove()">Remover modificação</button>

  </div>
</div>
